const jee = [
    {
        name:"Ignite",
        eligible:"Students Moving from X to XI",
        duration:"Two Year",
        session:"2023-25"
    },
    {
        name:"Prime",
        eligible:"Students Moving from XI to XII",
        duration:"One Year",
        session:"2024-25"
    },
    {
        name:"Phoenix",
        eligible:"XII Passed Students",
        duration:"One Year",
        session:"2024-25"
    }
];
export default jee;